import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const CustomWebshopRoute: Route = {
  path: '',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/cus-webshop.component').then((m) => m.CusWebshopComponent),
    },
    {
      path: 'product/:id',
      loadComponent: () => import('./pages/cus-product-details.component').then((m) => m.CusProductDetailComponent),
    },
    {
      path: 'shopping-cart',
      loadComponent: () => import('./pages/cus-shopping-cart.component').then((m) => m.CusShoppingCartComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
